import React, { createContext, useContext, useEffect, useState } from 'react';
import { instance, instanceMob } from '../../utils/utils';

const DashboardContext = createContext({ company: null, selectedLocationId: '', selectedLocation: null, locations: [], locationsLoading: false, locationsError: false, setSelectedLocationId: () => {}, reloadLocations: () => {}, updateCompany: () => {} });

export function DashboardProvider({ children }) {
    const [company, updateCompany] = useState(null);
    const [locations, setLocations] = useState([]);
    const [selectedLocationId, setSelectedLocationId] = useState('');
    const [locationsLoading, setLocationsLoading] = useState(false);
    const [locationsError, setLocationsError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    const mobEnabled = Boolean(localStorage.getItem('mob_api_key'));
    useEffect(() => {
        const controller = new AbortController();
        instance.get('memberships/corp/company', { signal: controller.signal })
            .then(({ data }) => { if (!controller.signal.aborted) updateCompany(data); })
            .catch(() => {});
        return () => controller.abort();
    }, []);
    useEffect(() => {
        if (!mobEnabled) return;
        const controller = new AbortController();
        setLocationsLoading(true);
        setLocationsError(false);
        instanceMob.get('admin/location/list', { signal: controller.signal })
            .then(({ data }) => {
                if (controller.signal.aborted) return;
                const items = Array.isArray(data) ? data : data?.results || [];
                setLocations(items);
                setSelectedLocationId(current => items.some(item => String(item.id) === current) ? current : '');
            })
            .catch(() => { if (!controller.signal.aborted) setLocationsError(true); })
            .finally(() => { if (!controller.signal.aborted) setLocationsLoading(false); });
        return () => controller.abort();
    }, [mobEnabled, attempt]);
    const selectedLocation = locations.find(item => String(item.id) === selectedLocationId) || null;
    return <DashboardContext.Provider value={{ company, updateCompany, locations, selectedLocationId, setSelectedLocationId, selectedLocation, locationsLoading, locationsError, reloadLocations: () => setAttempt(n => n + 1) }}>{children}</DashboardContext.Provider>;
}

export const useDashboardContext = () => useContext(DashboardContext);
